import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SideBar from '../SideBar/SideBar';
import Header from '../Header/Header';
import { fetchAndStoreMultipleDevicesTodayData } from '../redux/action/totalData';
import Loading from '../common/Loading';
import store from '../redux';
import { loadUnitSnapshot } from '../redux/action/dailyUnit';
import { selectedHouse as selectedHouseFromDropdown, selectedRoom as selectedRoomFromDropdown, selectedRoomDevices, selectedDeviceFromDropdown } from '../redux/action/deviceDropdownSelection';
import MainV2 from './MainV2';
import { selectedDay } from '../redux/action/selectedDate';
import { housesListAction } from '../redux/action/housesList';
import { selectedHouse } from '../redux/actionTypes';
import { config } from '../../config';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import DashBoard from '../DashBoard/DashBoard';
export const styles = {
  container: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
  },
  rightContainer: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
  },
};
function MainPage() {
  const params = useParams()
  const { selectedDeviceDetails: { deviceId: selectedDeviceId } = {}, roomId, devices } = useSelector(state => state.dropdownSelectionData);
  const houseData = useSelector(state => state.houseData);
  const [loading, setLoading] = useState(false);
  const [dateA, setDateA] = useState(new Date());
  const [roomCount, setRoomCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (Object.keys(houseData).length === 0) return;
      store.dispatch(selectedHouseFromDropdown(houseData._id))
      let startDate = dayjs().startOf('day');
      store.dispatch(selectedDay(startDate?.$d))
      // const roomsWithNonEmptyEnergySync = houseData?.rooms?.filter(room => room.energiSync.length > 0);
      const roomsWithNonEmptyEnergySync = houseData?.rooms?.filter(room => room?.energiSync.length > 0 || room?.weatherSensors.length>0 || room.thermoSmarts.length>0 || room.environSyncs.length>0 || room.doorSensors.length>0)
      if (roomsWithNonEmptyEnergySync.length === 0) return;
      setRoomCount(roomsWithNonEmptyEnergySync.length)
      const defaultRoom = Object.keys(params).length===0?roomsWithNonEmptyEnergySync[0]._id:params.roomId;
      const defaultRoomAllDevices = Object.keys(params).length===0?[...roomsWithNonEmptyEnergySync[0].energiSync.map((e)=>{
        return{...e,"type":config.deviceType.energiSync}
      }),...roomsWithNonEmptyEnergySync[0].thermoSmarts.map((e)=>{
        return{...e,"type":config.deviceType.thermoSmarts}
      }),...roomsWithNonEmptyEnergySync[0].weatherSensors.map((e)=>{
        return{...e,"type":config.deviceType.weatherSensors}
      }),...roomsWithNonEmptyEnergySync[0].environSyncs.map((e)=>{
        return{...e,"type":config.deviceType.environSyncs}
      }),...roomsWithNonEmptyEnergySync[0].doorSensors.map((e)=>{
        return{...e,"type":config.deviceType.doorSensors}
      })]:[...roomsWithNonEmptyEnergySync.find((room) => room._id === params.roomId)[params.type].map((e)=>{
        return {...e,"type":config.deviceType[params.type]}
      })]

      const defaultDeviceDetails = Object.keys(params).length===0?defaultRoomAllDevices[0]:defaultRoomAllDevices.find((device) => device.deviceId === params.deviceId);
      
      store.dispatch(selectedRoomFromDropdown(defaultRoom));
      store.dispatch(selectedRoomDevices(defaultRoomAllDevices));
      store.dispatch(selectedDeviceFromDropdown(defaultDeviceDetails));

  
    };

    fetchData();

    // Cleanup function
    return () => {
      // Add any necessary cleanup logic here if needed in the future
    };
  }, [houseData,params]);

  return (
    <div style={{ ...styles.container }}>
      {/* <SideBar /> */}
      <div style={{ ...styles.rightContainer }}>
        <Header />
        <MainV2 setLoading={setLoading} dateA={dateA} setDateA={setDateA} setRoomCount={setRoomCount} roomCount={roomCount} />
      </div>
      {loading && <Loading />}
    </div>
  );
}

export default MainPage;
